"use strict";

module.exports = {
  colorBackgroundDark: '#0F7C50',
  colorBackgroundDefault: '#11BB77',
  colorBackgroundLight: '#49E295',
  colorBackgroundNeutral10: '#EDF0EF',
  colorBackgroundNeutral20: '#C7CEC9',
  colorBackgroundWhite: '#FFFFFF',
  colorBrandPrimaryDark: '#0F7C50',
  colorBrandPrimaryDefault: '#11BB77',
  colorBrandPrimaryLight: '#49E295',
  colorBrandSecondaryDark: '#2159A3',
  colorBrandSecondaryDefault: '#1B75DD',
  colorBrandSecondaryLight: '#97DAFF',
  colorButtonNeutral10: '#EDF0EF',
  colorButtonPrimaryLight: '#49E295',
  colorDividerNeutral10: '#EDF0EF',
  colorDividerNeutral20: '#C7CEC9',
  colorDividerNeutral60: '#6F7974',
  colorFeedbackError: '#DE1212',
  colorFeedbackInformational: '#3D9C96',
  colorFeedbackSuccess: '#11BB77',
  colorFeedbackWarning: '#EC8308',
  colorFontNeutral60: '#6F7974',
  colorFontNeutral90: '#1F2D27',
  colorFontNeutralWhite: '#FFFFFF',
  colorIconNeutral60: '#6F7974',
  colorIconNeutral90: '#1F2D27',
  colorIconSecondaryDefault: '#1B75DD',
  colorIconWhite: '#FFFFFF',
  colorLinkPrimaryLight: '#49E295',
  colorNeutral10: '#EDF0EF',
  colorNeutral15: '#DBE1DD',
  colorNeutral20: '#C7CEC9',
  colorNeutral40: '#A5AEA7',
  colorNeutral60: '#6F7974',
  colorNeutral80: '#596B64',
  colorNeutral90: '#1F2D27',
  colorNeutral100: '#000000',
  colorNeutralWhite: '#FFFFFF',
  desktopInputFamily: 'Helvetica Now Display',
  desktopInputLineHeight: '80px',
  desktopInputSize: '64px',
  desktopInputSpacing: '0.5px',
  desktopInputWeight: '300',
  desktopLinkLGFamily: 'Helvetica Now Display',
  desktopLinkLGLineHeight: '32px',
  desktopLinkLGSize: '20px',
  desktopLinkLGSpacing: '0.3px',
  desktopLinkLGWeight: '500',
  desktopLinkMDFamily: 'Helvetica Now Display',
  desktopLinkMDLineHeight: '32px',
  desktopLinkMDSize: '20px',
  desktopLinkMDSpacing: '0.3px',
  desktopLinkMDWeight: '500',
  desktopOverlineFamily: 'Helvetica Now Display',
  desktopOverlineLineHeight: '20px',
  desktopOverlineSize: '14px',
  desktopOverlineSpacing: '1.5px',
  desktopOverlineWeight: '700',
  desktopParagraphLG300Family: 'Helvetica Now Display',
  desktopParagraphLG300LineHeight: '28px',
  desktopParagraphLG300Size: '20px',
  desktopParagraphLG300Spacing: '0.5px',
  desktopParagraphLG300Weight: '300',
  desktopParagraphMD400Family: 'Helvetica Now Display',
  desktopParagraphMD400LineHeight: '24px',
  desktopParagraphMD400Size: '16px',
  desktopParagraphMD400Spacing: '0.3px',
  desktopParagraphMD400Weight: '400',
  desktopParagraphMD700Family: 'Helvetica Now Display',
  desktopParagraphMD700LineHeight: '24px',
  desktopParagraphMD700Size: '16px',
  desktopParagraphMD700Spacing: '0.3px',
  desktopParagraphMD700Weight: '700',
  desktopParagraphSM400Family: 'Helvetica Now Display',
  desktopParagraphSM400LineHeight: '20px',
  desktopParagraphSM400Size: '14px',
  desktopParagraphSM400Spacing: '0.3px',
  desktopParagraphSM400Weight: '400',
  desktopParagraphSM700Family: 'Helvetica Now Display',
  desktopParagraphSM700LineHeight: '20px',
  desktopParagraphSM700Size: '14px',
  desktopParagraphSM700Spacing: '0.3px',
  desktopParagraphSM700Weight: '700',
  desktopParagraphXS400Family: 'Helvetica Now Display',
  desktopParagraphXS400LineHeight: '16px',
  desktopParagraphXS400Size: '12px',
  desktopParagraphXS400Spacing: '0.3px',
  desktopParagraphXS400Weight: '400',
  desktopTitleLG300Family: 'Helvetica Now Display',
  desktopTitleLG300LineHeight: '56px',
  desktopTitleLG300Size: '40px',
  desktopTitleLG300Spacing: '0.5px',
  desktopTitleLG300Weight: '300',
  desktopTitleMD300Family: 'Helvetica Now Display',
  desktopTitleMD300LineHeight: '48px',
  desktopTitleMD300Size: '32px',
  desktopTitleMD300Spacing: '0.5px',
  desktopTitleMD300Weight: '300',
  desktopTitleSM400Family: 'Helvetica Now Display',
  desktopTitleSM400LineHeight: '32px',
  desktopTitleSM400Size: '24px',
  desktopTitleSM400Spacing: '0.5px',
  desktopTitleSM400Weight: '400',
  desktopTitleSM700Family: 'Helvetica Now Display',
  desktopTitleSM700LineHeight: '32px',
  desktopTitleSM700Size: '24px',
  desktopTitleSM700Spacing: '0.5px',
  desktopTitleSM700Weight: '700',
  desktopTitleXS400Family: 'Helvetica Now Display',
  desktopTitleXS400LineHeight: '28px',
  desktopTitleXS400Size: '20px',
  desktopTitleXS400Spacing: '0.5px',
  desktopTitleXS400Weight: '400',
  desktopTitleXS700Family: 'Helvetica Now Display',
  desktopTitleXS700LineHeight: '28px',
  desktopTitleXS700Size: '20px',
  desktopTitleXS700Spacing: '0.5px',
  desktopTitleXS700Weight: '700',
  desktopTitleXL300Family: 'Helvetica Now Display',
  desktopTitleXL300LineHeight: '48px',
  desktopTitleXL300Size: '64px',
  desktopTitleXL300Spacing: '0.5px',
  desktopTitleXL300Weight: '300',
  mobileInputFamily: 'Helvetica Now Display',
  mobileInputLineHeight: '80px',
  mobileInputSize: '64px',
  mobileInputSpacing: '0.5px',
  mobileInputWeight: '300',
  mobileLinkLGFamily: 'Helvetica Now Display',
  mobileLinkLGLineHeight: '32px',
  mobileLinkLGSize: '20px',
  mobileLinkLGSpacing: '0.3px',
  mobileLinkLGWeight: '500',
  mobileLinkMDFamily: 'Helvetica Now Display',
  mobileLinkMDLineHeight: '32px',
  mobileLinkMDSize: '20px',
  mobileLinkMDSpacing: '0.3px',
  mobileLinkMDWeight: '500',
  mobileOverlineFamily: 'Helvetica Now Display',
  mobileOverlineLineHeight: '20px',
  mobileOverlineSize: '14px',
  mobileOverlineSpacing: '1.5px',
  mobileOverlineWeight: '700',
  mobileParagraphLG400Family: 'Helvetica Now Display',
  mobileParagraphLG400LineHeight: '24px',
  mobileParagraphLG400Size: '16px',
  mobileParagraphLG400Spacing: '0.3px',
  mobileParagraphLG400Weight: '400',
  mobileParagraphLG700Family: 'Helvetica Now Display',
  mobileParagraphLG700LineHeight: '24px',
  mobileParagraphLG700Size: '16px',
  mobileParagraphLG700Spacing: '0.3px',
  mobileParagraphLG700Weight: '700',
  mobileParagraphMD400Family: 'Helvetica Now Display',
  mobileParagraphMD400LineHeight: '20px',
  mobileParagraphMD400Size: '14px',
  mobileParagraphMD400Spacing: '0.3px',
  mobileParagraphMD400Weight: '400',
  mobileParagraphMD700Family: 'Helvetica Now Display',
  mobileParagraphMD700LineHeight: '20px',
  mobileParagraphMD700Size: ' 14px',
  mobileParagraphMD700Spacing: '0.3px',
  mobileParagraphMD700Weight: '700',
  mobileParagraphSM400Family: 'Helvetica Now Display',
  mobileParagraphSM400LineHeight: '16px',
  mobileParagraphSM400Size: '12px',
  mobileParagraphSM400Spacing: '0.3px',
  mobileParagraphSM400Weight: '400',
  mobileTitleLG300Family: 'Helvetica Now Display',
  mobileTitleLG300LineHeight: '36px',
  mobileTitleLG300Size: '26px',
  mobileTitleLG300Spacing: '0px',
  mobileTitleLG300Weight: '300',
  mobileTitleMD300Family: 'Helvetica Now Display',
  mobileTitleMD300LineHeight: '32px',
  mobileTitleMD300Size: '22px',
  mobileTitleMD300Spacing: '0px',
  mobileTitleMD300Weight: '300',
  mobileTitleSM300Family: 'Helvetica Now Display',
  mobileTitleSM300LineHeight: '28px',
  mobileTitleSM300Size: '18px',
  mobileTitleSM300Spacing: '0px',
  mobileTitleSM300Weight: '300',
  mobileTitleSM400Family: 'Helvetica Now Display',
  mobileTitleSM400LineHeight: '28px',
  mobileTitleSM400Size: '18px',
  mobileTitleSM400Spacing: '0px',
  mobileTitleSM400Weight: '400',
  mobileTitleSM700Family: 'Helvetica Now Display',
  mobileTitleSM700LineHeight: '28px',
  mobileTitleSM700Size: '18px',
  mobileTitleSM700Spacing: '0px',
  mobileTitleSM700Weight: '700',
  mobileTitleXL300Family: 'Helvetica Now Display',
  mobileTitleXL300LineHeight: '40px',
  mobileTitleXL300Size: '30px',
  mobileTitleXL300Spacing: '0px',
  mobileTitleXL300Weight: '300'
};